import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore, selectIsAuthenticated, selectUser } from '../stores/authStore'

/**
 * Route guard for /admin. Silently redirects non-admins to /home.
 * Regular users never see an error message — the route simply doesn't exist for them.
 */
export default function AdminRoute() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const user = useAuthStore(selectUser)

  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (!user?.is_admin) return <Navigate to="/home" replace />

  return <Outlet />
}
